<div class="card card--campaign">
    <div class="card-head card-head--campaign">
        <img src="" class="card-img-top">
    </div>
    <div class="card-body card-body--campaign">
        <div class="card-title card-title--campaign-name">Campaign Donation&gt;</div>
        <div class="card-text card-text--campaign-description quill-description mb-4">Campaign Donation Description</div>
        <div class="campaign-goal">
            <div class="d-flex mb-2">
                <div class="campaign-goal__raised mr-2">$0</div>
                <div class="campaign-goal__raised-of"></div>
            </div>
            <div class="progress progress--donor-page">
                <div class="progress-bar progress-bar--donor-page" role="progressbar" style="width: 0%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
        </div>
    </div>
    <a class="card_anchor" rel="nofollow" id="card_0"> </a>
</div>